// Converts to sentence case
// Removes spaces before capital letters
// Example - "With Icons" would become "With icons"

export function toSentenceCase(str) {
    const newStr = str
        .replace(/([A-Z])/g, " $1")
        .trim()
        .toLowerCase();
    const newStr2 = str.charAt(0).toUpperCase() + newStr.slice(1);
    return newStr2;
}
